export const Today = () => new Date().toISOString().substring(0, 10);
export const printableTime = (hours: number, minutes: number, seconds?: number) =>
  [
    `${hours < 10 ? "0" : ""}${hours}`,
    `${minutes < 10 ? "0" : ""}${minutes}`,
    seconds !== undefined && `${seconds < 10 ? "0" : ""}${seconds}`,
  ]
    .filter(Boolean)
    .join(":");

/**
 * Get the created date from an item.
 * Used when items can have either created_at or createdAt
 * @param item - The item to get the created date from
 * @returns The created date
 */
export const getCreatedDate = (item: any): Date | null => {
  if (item?.created_at) return new Date(item.created_at);
  if (item?.createdAt) return new Date(item.createdAt);
  return null;
};
